import React from "react";
import PageHero from "../components/PageHero";
import QuoteForm from "../components/QuoteForm";
import { company, heroImages } from "../mock";
import { MapPin, Phone, Mail, Clock, Send } from "lucide-react";
import SEO from "../components/SEO";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Us — Get a Quote"
        description="Contact Ruken Alazdehar General Trading LLC. Office at Business Village A, Port Saeed, Dubai. Call +971 56 3898675 or +971 4 376 4958, or email info@rukenalazdehar.ae for quotes on industrial raw materials."
        path="/contact-us"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "Ruken Alazdehar General Trading LLC",
          telephone: "+971-56-3898675",
          email: "info@rukenalazdehar.ae",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Business Village A, Office No. 658, Port Saeed, Al Maktoum Road",
            postalCode: "186885",
            addressLocality: "Dubai",
            addressCountry: "AE",
          },
        }}
      />
      <PageHero
        title="Got a Query?"
        subtitle="Need help? Reach out to us — our trade team is available across business hours to support your sourcing needs."
        breadcrumbs={[{ label: "Contact Us" }]}
        bgImage={heroImages.contact}
      />

      <section className="section-padding bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-6 mb-14">
            {[
              { Icon: MapPin, title: "Office", text: company.address, action: null },
              { Icon: Phone, title: "Call us", text: company.phone, action: `tel:${company.phone}` },
              { Icon: Mail, title: "Email us", text: company.email, action: `mailto:${company.email}` },
            ].map((c, i) => {
              const Inner = (
                <div className="p-7 rounded-xl border border-border bg-muted/20 card-hover h-full">
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4" style={{ background: "var(--brand-100)" }}>
                    <c.Icon size={22} style={{ color: "var(--brand-700)" }} />
                  </div>
                  <h3 className="font-display font-semibold text-lg text-brand" style={{ color: "var(--brand-700)" }}>{c.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground">{c.text}</p>
                </div>
              );
              return c.action ? (
                <a key={i} href={c.action} className="block fade-in">{Inner}</a>
              ) : (
                <div key={i} className="fade-in">{Inner}</div>
              );
            })}
          </div>

          <div className="grid lg:grid-cols-2 gap-10 items-start">
            <div className="fade-in">
              <p className="text-xs uppercase tracking-[0.3em] font-semibold" style={{ color: "var(--brand-500)" }}>Working Time</p>
              <h2 className="font-display text-3xl md:text-4xl font-bold text-brand mt-2 leading-tight" style={{ color: "var(--brand-700)" }}>
                Visit us at Business Village A, Port Saeed.
              </h2>
              <div className="mt-5 flex items-center gap-3 text-foreground/85">
                <Clock size={18} style={{ color: "var(--brand-500)" }} /> {company.hours}
              </div>
              <p className="mt-6 text-muted-foreground leading-relaxed">
                We aspire to create a global channel for a solid future. Discover what makes our business stand out!
              </p>
              <div className="mt-7 rounded-xl overflow-hidden border border-border shadow-sm aspect-[16/11]">
                <iframe
                  title="Ruken Alazdehar Office Location"
                  src="https://www.google.com/maps?q=Business+Village+A,+Port+Saeed,+Al+Maktoum+Road,+Dubai&output=embed"
                  className="w-full h-full border-0"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
            <div className="fade-in">
              <div className="mb-5">
                <p className="text-xs uppercase tracking-[0.3em] font-semibold" style={{ color: "var(--brand-500)" }}>Send us a Query</p>
                <h3 className="font-display text-2xl md:text-3xl font-bold text-brand mt-2" style={{ color: "var(--brand-700)" }}>Tell us how we can help.</h3>
              </div>
              <QuoteForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
